export const getHelperTextStyles = ({ error }) => ({
  position: 'absolute',
  width: '100%',
  top: '100%',
  left: 0,
  paddingTop: '4px',
  margin: 0,
  color: ({ palette }) => `${palette.text[error ? 'error' : 'secondary']} !important`,
  zIndex: 1,
});
